import { DisneyData } from "@/data/disney-wdw-data"

export namespace WDW {
	const toGoSlugs = [
		"sanaa",
		"goods-food-to-go", //  ??
		"kona-cafe",
		"olivia-cafe",
		"steakhouse-71",
		"trattoria-al-forno",
		"ale-and-compass",
		"wailulu-bar-grill",
	]
	const admissionRequiredLocations = [
		"Magic Kingdom Park",
		"EPCOT",
		"Disney's Hollywood Studios",
		"Disney's Animal Kingdom Theme Park",
		"Disney's Blizzard Beach Water Park",
		"Disney's Typhoon Lagoon Water Park",
	]
	export type Data = {
		Entries: Entry[]
		Locations: Record<string, string>
	}

	export type Entry = {
		Title: string
		Location: string
		Price: string
		TicketRequired: boolean
		AcceptsReservation: boolean
		MobileOrder: boolean
		Type: string
		Slug: string
		Link: string
	}

	export function generate(): Data {
		const result: Data = {
			Entries: [],
			Locations: {},
		}

		for (const location of admissionRequiredLocations) {
			result.Locations[location] = location
		}

		DisneyData.DiningDataExport.results.forEach((x) => {
			if (!x.locationName) {
				return
			}

			if (!Object.keys(result.Locations).includes(x.locationName)) {
				result.Locations[x.locationName] = x.locationName
			}

			let price = "?"
			if (x.facets.priceRangeDining?.length) {
				price = x.facets.priceRangeDining[0]
			}

			let acceptsMobileOrders =
				x.facets.features?.includes("mobile-orders") ?? false

			if (toGoSlugs.includes(x.urlFriendlyId)) {
				acceptsMobileOrders = true
			}

			result.Entries.push({
				AcceptsReservation: x.remyCheckAvailCta !== undefined,
				Link: x.webLinks.wdwDetail.href,
				Location: x.locationName,
				MobileOrder: acceptsMobileOrders,
				Price: price,
				Slug: x.urlFriendlyId,
				TicketRequired: admissionRequiredLocations.includes(x.locationName),
				Title: x.name,
				Type: x.entityType,
			})
		})

		return result
	}
}
